import styled from 'styled-components';

type BodyRowRootProps = {
  $stripColor: string | undefined;
};

export const BodyRowRoot = styled.tr<BodyRowRootProps>`
  ${({ $stripColor }) =>
    $stripColor
      ? `background: linear-gradient(to right, ${$stripColor} 6px, transparent 6px);`
      : undefined}
`;
